module.exports = __webpack_public_path__ + "img/first-3.3b691110.webp";